if (!customElements.get('campaign-announcement')) {
  customElements.define(
    'campaign-announcement',
    class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.status = this.querySelector('[data-status]');
        this.countdowns = Array.from(this.querySelectorAll('[data-countdown]'));
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.interval = Math.max(Number(this.dataset.interval) || 5000, 2500);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onVisibilityChange = () => (document.hidden ? this.stop() : this.start());
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.updateCountdowns();
        if (this.countdowns.length) {
          this.countdownTimer = window.setInterval(() => this.updateCountdowns(), 1000);
        }
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        window.clearInterval(this.countdownTimer);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      updateCountdowns() {
        const now = Date.now();

        this.countdowns.forEach((countdown) => {
          const endTime = Date.parse(countdown.dataset.end || '');
          if (!Number.isFinite(endTime)) {
            countdown.hidden = true;
            countdown.closest('.halloween-announcement-bar__inner')?.classList.remove('halloween-announcement-bar__inner--countdown');
            return;
          }

          const totalSeconds = Math.max(0, Math.floor((endTime - now) / 1000));
          const days = Math.floor(totalSeconds / 86400);
          const hours = Math.floor((totalSeconds % 86400) / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          const pad = (value) => String(value).padStart(2, '0');

          countdown.querySelector('[data-countdown-days]').textContent = pad(days);
          countdown.querySelector('[data-countdown-hours]').textContent = pad(hours);
          countdown.querySelector('[data-countdown-minutes]').textContent = pad(minutes);
          countdown.querySelector('[data-countdown-seconds]').textContent = pad(seconds);
          countdown.setAttribute('aria-label', `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`);
        });
      }

      start() {
        this.stop();
        if (this.slides.length < 2 || this.reducedMotion || document.hidden) return;
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
      }

      show(index) {
        const previous = this.slides[this.currentIndex];
        this.currentIndex = index % this.slides.length;
        const next = this.slides[this.currentIndex];

        previous.classList.remove('is-active');
        previous.classList.add('is-leaving');
        previous.setAttribute('aria-hidden', 'true');
        previous.setAttribute('inert', '');
        next.classList.remove('is-leaving');
        next.classList.add('is-active');
        next.setAttribute('aria-hidden', 'false');
        next.removeAttribute('inert');

        window.setTimeout(() => previous.classList.remove('is-leaving'), 520);
        if (this.status) this.status.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
      }
    }
  );
}
